import axios from "axios";
import { url } from "../../../../configlink";

export default axios.create({
  baseURL: `${url}/api/file/`,
  headers: {
    "Content-type": "application/json",
  },
});
